import * as CoreFns from '../../utilities/CoreFns';
import * as TypeEvaluation from '../../TypeEvaluation';
import * as RAFormula from './RAFormula';
import * as ResponsiveFns from '../../utilities/ResponsiveFns';
import * as StandardFns from '../../utilities/StandardFns';

export function findRForms(overallPath, currentList){
  var rFormSets = [];
  for (var i5 = 0; i5 < overallPath.length; i5++){
    if (overallPath[i5] === 'i'){
      var plusOne = overallPath.filter((aP, index)=>{
        return +index < i5 + 2;
      })
      var thisItem = CoreFns.goDownPath(currentList, plusOne);
      var thisItemS = thisItem.s;
      if (thisItemS){
        if (thisItemS.rFormula){
          if (thisItemS.rFormula.t === 'formula'){
            var upwardInfo = [];
            var objectType = TypeEvaluation.evalType(thisItemS.rFormula.o, plusOne, currentList, upwardInfo);
            var cType = objectType.c;
            if (!cType){
              cType = {t:'toDelete'};
            }
            rFormSets.push({type:cType, plusOne});
          }
        }
      }
    }
  }    
  return rFormSets;
}

function isPathBeforeReference(pathToHere, startPath){
  for (var i = 0; i < startPath.length; i++){
    if (pathToHere.length > i){
      var startI = startPath[i].i;
      var pathI = pathToHere[i].i;
      if (startI > pathI){
        return true;
      }else if (pathI > startI){
        return false;
      }
    }
  }
  return false;
}

export function findGap(keyPath, pathToHere, startPath, relevantSpace){
  var node = CoreFns.goDownPath(relevantSpace, keyPath, 0);
  var xS = node.x;
  if (xS.length === 0){
    return {keyPath, pathToHere};
  }else if (xS[0].t === 'u'){
    return {keyPath, pathToHere};
  }else{
    for (var i = 1; i < xS.length; i++){
      var key = xS[i].v;
      var path = ['y', key];
      var thisPath = pathToHere.concat([{k:key, i}]);
      var isBefore = isPathBeforeReference(thisPath, startPath);
      if (isBefore){
      }else{
        var p = findGap(path, thisPath, startPath, relevantSpace);
        if (p){
          return p;
        }          
      }
    }
  }
  return false;

}



export function getVarsAndTypeIn(pathToHere, relevantSpace, currentList, overallPath, actionCases){


  function workUpwardsToFigureOutType(pathToHere, whichDepth, varsIn){


    function seeIfParentsGiveClues(parentalType, nos){
      var p = workUpwardsToFigureOutType(pathToHere, whichDepth - 1, varsIn);

      if (p){
        function resolveAP(type, p1){
          if ((type.t === 'any' || type.t === 'nos' || type.t === 'free') && type.v === nos){
            return p1;
          }else if (type.t === 'MaybeSpecified' && p1.t === 'MaybeSpecified'){
            return resolveAP(type.c[0], p1.c[0]);
          }else if (type.t === 'ListType' && p1.t === 'ListType'){
            return resolveAP(type.c, p1.c);
          }else if (type.t === 'ListType' && p1.t === 'any'){
            return {t:'any'};
          }else{
            return false;
          }
        }

        return resolveAP(parentalType, p);
      }
      return false;
    }

    function seeIfOlderSiblingsGiveClues(elderSiblingType, nos, siblingId){
      if (elderSiblingType.t === 'ListType'){
        var inside1 = seeIfOlderSiblingsGiveClues(elderSiblingType.c, nos, siblingId);
        if (inside1){
          return {t:elderSiblingType.t, c:inside1};
        }else{
          return false;
        }
      }else if (elderSiblingType.t === 'MaybeSpecified'){
        var inside = seeIfOlderSiblingsGiveClues(elderSiblingType.c[0], nos, siblingId);
        if (inside){
          return {t:elderSiblingType.t, c:[inside]};
        }else{
          return false;
        }
        //the match piece below comes about cos of the add a list of numbers type. 
      }else if ((elderSiblingType.t === 'any' || elderSiblingType.t === 'nos' || elderSiblingType.t === 'match' ) && elderSiblingType.v === nos){
        return RAFormula.getTypeRequiredK(relevantSpace, ['y',siblingId,'x'], overallPath, currentList, varsIn, actionCases, true);
      }else{
        return false;
      }
    }

    function resolveAnInType(typeToResolve, relevantFn, currentChildToResolve, currentParentalOccupants){

      if (typeToResolve.t === 'match'){
        var parentalType = relevantFn.out;
        var p = seeIfParentsGiveClues(parentalType, typeToResolve.v);
        if (p){
          if (p.t === 'any' || p.t === 'nos'){
            if (currentChildToResolve === 0){
              return p;
            }
          }else{
            return p;
          }
        }

        for (var i = 0; i < currentChildToResolve; i++){
          var elderSiblings = relevantFn.in;
          var relevantOlderSibling = currentParentalOccupants[i + 1];
          var p1 = seeIfOlderSiblingsGiveClues(elderSiblings[i], typeToResolve.v, relevantOlderSibling.v);
          if (p1){
            return p1;
          }
        }

        if (p){
          return p;
        }
        return false;
      }else if (typeToResolve.t === 'ListType'){
        var inside1 = resolveAnInType(typeToResolve.c, relevantFn, currentChildToResolve, currentParentalOccupants);
        if (inside1){
          return {t:typeToResolve.t, c:inside1}
        }else{
          return false;
        }
      }else if (typeToResolve.t === 'MaybeSpecified'){
        var inside = resolveAnInType(typeToResolve.c[0], relevantFn, currentChildToResolve, currentParentalOccupants);
        if (inside){
          return {t:typeToResolve.t, c:[inside]}
        }else{
          return false;
        }
      }else{
        return typeToResolve;
      }
    }

    if (whichDepth === -1){
      var origType;
      if (relevantSpace.out){
        origType = relevantSpace.out;
      }else{
        if (!origType){
          origType = relevantSpace.r;
        }
      }
      return origType;
    }else{
      var relevantPointer = pathToHere[whichDepth];
      var currentParentalOccupants = [];
      if (relevantPointer.p === ''){
        currentParentalOccupants = relevantSpace.x;
      }else{
        var node = CoreFns.goDownPath(relevantSpace, ["y", relevantPointer.p], 0);
        currentParentalOccupants = node.x;
      }
      var inputTargetted = relevantPointer.i - 1;
      var firstParentalNode = currentParentalOccupants[0];
      if (firstParentalNode.t === 'f'){
        if (firstParentalNode.v === 61){
          var parent = workUpwardsToFigureOutType(pathToHere, whichDepth - 1, varsIn);
          if (parent.t === 'any'){
            return parent;
          }else{
            var relevantChildTi = currentParentalOccupants[inputTargetted + 1].ti;
            for (var i7 = 0; i7 < parent.c.length; i7++){
              if (parent.c[i7].n === relevantChildTi){
                return parent.c[i7].t;
              }
            }
          }
          return false;
        }else{
          var fns = StandardFns.functionalPieces;
          var relevantFn = fns[firstParentalNode.v];
          var ins = relevantFn.in;
          var relevantInVal;
          if (inputTargetted < ins.length){
            relevantInVal = ins[inputTargetted];
          }else{
            // inputTargetted = ins.length - 1;
            relevantInVal = ins[ins.length - 1];
          }
          var pp = resolveAnInType(relevantInVal, relevantFn, inputTargetted, currentParentalOccupants);
          return pp;
        }
      }else if (firstParentalNode.t === 'u'){
        return false;
      }else if (CoreFns.withP(firstParentalNode.t)){
        return {t:'UInteger'}; //this is because everything that follows from an O that's used is an int. unless there's some change       
      }else if (firstParentalNode.t === 'inP'){
        return false;
      }else if (firstParentalNode.t === 'eS' ){
        var listLength = TypeEvaluation.countLists(firstParentalNode.p);
        var thisAbi = ResponsiveFns.getToRelevantAbi(firstParentalNode, currentList); 
        if (thisAbi){
          var inputs = thisAbi.inputs;
          if (inputs.length > inputTargetted){
            return TypeEvaluation.convertSCTypeToInternalType(inputs[inputTargetted]);
          }else if (inputs.length + listLength === inputTargetted){ //this only applies for eS and tf
            return {t:'ListType', c:{t:'ScEvent',v:firstParentalNode.s}};
          }else{
            return {t:'UInteger'};
          }
        }
        return {t:'toDelete'};
      }else if (firstParentalNode.t === 'eV'){
        var thisAbi1 = ResponsiveFns.getToRelevantAbi(firstParentalNode, currentList); 
        if (thisAbi1){
          var inputs11 = thisAbi1.inputs;
          var nosInputsUsed = 0;
          for (var i8 = 0; i8 < inputs11.length; i8++){
            var thisInput = inputs11[i8];
            if (thisInput.indexed){
              if (nosInputsUsed === inputTargetted){
                var tt = TypeEvaluation.convertSCTypeToInternalType(inputs11[i8]);
                return {t:'MaybeSpecified',c:[tt]};
              }else{
                nosInputsUsed ++;
              }
            }
          }
        }
        return {t:'toDelete'};
      }else{
        console.warn(firstParentalNode);
      }
    }
  }


    var parentals = "";
    pathToHere.forEach((aP, index)=>{
      aP.p = parentals;
      parentals = aP.k;
    })

    var varsIn = RAFormula.findAllVariablesWithTheirAssociatedTypesMarch(relevantSpace, pathToHere, overallPath, currentList, actionCases);
    var typeRequired = workUpwardsToFigureOutType(pathToHere, pathToHere.length - 1, varsIn);
    if (!typeRequired){
      typeRequired = {t:'toDelete'};
    }
    return {varsIn, typeRequired}    
}

